import LoadingIcon from "components/Loading/LoadingIcon";
import type {
  PartABPlanCoverageType,
  PartCDPlanCoverageType,
} from "types/DataTypes";

import { PartABForm } from "../forms/PartABForm";
import { PartCDForm } from "../forms/PartCDForm";
import type { NoContentMessageProps } from "../types";

const NoContentMessage = ({ message }: NoContentMessageProps) => (
  <div className="data-block" style={{ columnSpan: "all" }}>
    <div className="data-block-header">Coverage Information</div>
    <div className="data-values" style={{ display: "block" }}>
      <p className="text-center">{message}</p>
    </div>
  </div>
);

type CoverageListProps = {
  allCoverages: Array<
    | (PartABPlanCoverageType & { coverageType: "AB" })
    | (PartCDPlanCoverageType & { coverageType: "CD" })
  >;
  isLoading: boolean;
  hasCoverage: boolean;
  isCoverageComplete?: boolean;
  isNoCoverage?: boolean;
};

export const CoverageList = ({
  allCoverages,
  isLoading,
  hasCoverage,
  isCoverageComplete,
  isNoCoverage,
}: CoverageListProps) => {
  const getMessage = () => {
    if (isCoverageComplete && !hasCoverage) return "Coverage marked complete.";
    if (isNoCoverage) return "No Coverage Selected.";
    if (!hasCoverage) return "No Coverage Information Exists.";
    return null;
  };

  const message = getMessage();

  return (
    <>
      {isLoading ? (
        <div className="swim-column">
          <div className="data-block">
            <div className="data-block-header">Coverage Information</div>
            <div className="data-values" style={{ display: "block" }}>
              <div className="text-center" style={{ padding: "2rem" }}>
                <LoadingIcon message="Loading coverage information..." />
              </div>
            </div>
          </div>
        </div>
      ) : message ? (
        <div className="swim-column">
          <NoContentMessage message={message} />
        </div>
      ) : (
        <>
          {allCoverages.map((coverage) => (
            <div className="swim-column" key={coverage.id}>
              {coverage.coverageType === "AB" ? (
                <PartABForm
                  coverage={coverage}
                  isComplete={isCoverageComplete}
                />
              ) : (
                <PartCDForm
                  coverage={coverage}
                  isComplete={isCoverageComplete}
                />
              )}
            </div>
          ))}
        </>
      )}
    </>
  );
};
